<template>
            <PrimeButton @click="handleBusinessClick" label="Privacy Bee for Business" variant="business" class="p-btn-root_business w-full"/>
</template>

<script setup lang="ts">
const authStore = useAuthStore();
const config = useRuntimeConfig();

const handleBusinessClick = () => {
    const employer = authStore.user?.employer;
    
    if (employer?.id) {
        window.open(`${config.public.pb.appDomainLegacy}/business/${employer.slug}/apps`, '_blank');
    } else {
        window.open('https://business.privacybee.com', '_blank');
    }
};
</script>

<style lang="scss" scoped>
    * {
        font-family: 'Inter', sans-serif;
    }
</style>
